import { ComponentModel } from '../../../api/api';

export type ContextSubdomains = ReadonlyMap<string, { id: string; name: string }>;

export function groupComponentsBySubdomain<T extends Pick<ComponentModel, 'name' | 'contextId'>>(components: T[], contextSubdomains: ContextSubdomains) {
	const groups = new Map<string, { id: string; name: string; order: number; components: T[] }>();
	for (const component of components) {
		const subdomain = component.contextId ? contextSubdomains.get(component.contextId) : undefined;
		const id = subdomain ? 'subdomain:' + subdomain.id : component.contextId ? 'unresolved' : 'without-context';
		let group = groups.get(id);
		if (!group) {
			group = {
				id,
				name: subdomain?.name ?? (component.contextId ? 'Subdomain unavailable' : 'Without a context'),
				order: subdomain ? 0 : component.contextId ? 1 : 2,
				components: [],
			};
			groups.set(id, group);
		}
		group.components.push(component);
	}
	return Array.from(groups.values())
		.sort((left, right) => left.order - right.order || left.name.localeCompare(right.name))
		.map((group) => ({ ...group, components: [...group.components].sort((left, right) => left.name.localeCompare(right.name)) }));
}
